'use client';

import { Popover, PopoverButton, PopoverGroup } from '@headlessui/react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import clsx from 'clsx';

import { HEADER_NAVIGATIONS } from '@lib/constants/navigations';
import { useHeaderStore } from '@lib/stores/useHeaderStore';
import { Button } from '@components/common/button';

import { LowerHeaderFilters } from './filters';

export function LowerHeaderLinks() {
  const { category, setCategory } = useHeaderStore();
  const pathname = usePathname();

  return (
    <nav className='ml-6'>
      <PopoverGroup as='ul' className='hidden xl:flex justify-center gap-x-8'>
        {HEADER_NAVIGATIONS.map((nav) => (
          <Popover as='li' key={nav.label}>
            {({ open, close }) => {
              const CustomButton = nav.href ? Button : PopoverButton;

              return (
                <>
                  <CustomButton
                    as={Button}
                    asChild={nav.href !== undefined}
                    variant='link'
                    className={clsx(
                      'w-fit p-0 text-sm hover:text-primary-foreground outline-none',
                      (nav.value === category || nav.href === pathname) && open
                        ? 'text-primary-foreground underline'
                        : 'text-primary-foreground/80',
                    )}
                    onClick={
                      nav.value ? () => setCategory(nav.value) : undefined
                    }
                  >
                    {nav.href ? (
                      <Link href={nav.href}>{nav.label}</Link>
                    ) : (
                      nav.label
                    )}
                  </CustomButton>
                  <LowerHeaderFilters onClose={close} />
                </>
              );
            }}
          </Popover>
        ))}
      </PopoverGroup>
    </nav>
  );
}
